export const PASSWORD_RECOVERY_STEPPER_NAMESPACE = 'password-recovery';

export enum PASSWORD_RECOVERY_STEPS {
  RESET_PASSWORD = 'reset-password',
  REQUEST_OTP = 'request-otp',
}
